/** Per-calculator permission gates (calculators module still required). */

export function hasCalculatorAccess(
  calculatorId: string,
  permissions: string[] | undefined | null,
): boolean {
  if (!permissions?.length) return false;
  if (permissions.includes("*") || permissions.includes("admin:*")) return true;
  if (permissions.includes("calculators:*")) return true;
  const slug = calculatorId.replace(/-/g, "_");
  return (
    permissions.includes(`calculators:${calculatorId}`) ||
    permissions.includes(`calculators:${slug}`)
  );
}

export function filterCalculatorsByAccess<T extends { id: string }>(
  calculators: T[],
  permissions: string[] | undefined | null,
): T[] {
  return calculators.filter((c) => hasCalculatorAccess(c.id, permissions));
}
